import React, { useEffect, useState } from 'react';
import { makeRequest, updateCartState } from '../../utils';
import { useRecoilState } from 'recoil';
import { cartState } from '../../atoms';
import styles from './cart.module.css';
import { priceIndex } from './prices';


export default function AddToCart({ id, context, outOfStock = false }) {
  const [inStock, setInStock] = useState(true);
  const [cart, setCart] = useRecoilState(cartState);
  const [product, setProduct] = useState({});
  const [price, setPrice] = useState('');
  const [preorder, setPreorder] = useState(false);
  const [cost, setCost] = useState(15.99);

  const checkInStock = async () => {

    if (outOfStock) {
      console.log('Got here')
      setInStock(false);
      return;
    }
    let data = await makeRequest(`https://asterismbooks.com/api/product?id=${id}&key=odsfi324823ref90fdsdf`);
    setProduct(data);
    setCost(data.prices.retail);
    // Check if publicationDate is in the future
    if (data.publicationDate && new Date(data.publicationDate) > new Date()) {
      console.log('Preorder detected');
      setPreorder(true);
    }
    setInStock(data.inventory.asterism > 0);
  }

  const addToCart = () => {
    let item = {
      id: product._id,
      priceId: price,
      title: product.title,
      author: product.authors.join(', '),
      image: product.cover['300'],
      price: product.prices.retail,
      weight: product.dimensions.weight,
    }
    let newCart = updateCartState(cart, item);
    setCart(newCart);
  }

  useEffect(() => {
    if (id) {
      try {
        setPrice(window.location.hostname === 'hanumaneditions.com' ? priceIndex[id].prod : priceIndex[id].test)
      } catch (e) {
        console.log(id);
      }
      checkInStock()
    } else {
      setInStock(false);
    }
  }, [id]);

  if (context !== 'product') {
    return (
      inStock || preorder ? <button className={`${styles.addToCartButtonSmall}`} onClick={addToCart}>
        <span><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.895996" y="9.60449" width="18.2083" height="0.791665" rx="0.395833" fill="" stroke="" stroke-width="0.5" />
          <rect x="10.396" y="0.895508" width="18.2083" height="0.791665" rx="0.395833" transform="rotate(90 10.396 0.895508)" fill="" stroke="6" stroke-width="0.5" />
        </svg></span>
      </button> : <button className={`${styles.addToCartButtonSmall}`} disabled><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.895996" y="9.60449" width="18.2083" height="0.791665" rx="0.395833" fill="#262626" stroke="#262626" stroke-width="0.5" />
        <rect x="10.396" y="0.895508" width="18.2083" height="0.791665" rx="0.395833" transform="rotate(90 10.396 0.895508)" fill="#262626" stroke="#262626" stroke-width="0.5" />
      </svg></button>
    )
  }


  return (
    <>
      {(inStock || preorder) ? <button className={`${styles.addToCartButton}`} onClick={addToCart}>
        <span>{preorder ? 'Preorder' : 'Add to Cart'}</span>
      </button> : <button className={`${styles.addToCartButton}`} disabled>Out of Stock</button>}
    </>
  )
}